import * as yup from 'yup'
import { generateAttributesValidationSchema, TRule } from 'utils'
import { TAttribute } from 'types'

export const blendSchema = (
  rules: Record<string, { min: number; max: number }>
) => {
  return yup.object().shape({
    attributes: yup
      .array()
      .of(generateAttributesValidationSchema(rules))
      .defined(),

    limitations: yup.array().of(
      yup.object().shape({
        bin_id: yup
          .number()
          .typeError('Bin ID is required')
          .required('Bin ID is required'),
        limitation_id: yup
          .number()
          .typeError('Limitation ID is required')
          .required('Limitation ID is required'),
        value: yup
          .number()
          .typeError('Amount must be a valid number')
          .min(0, 'Amount must be greater than or equal to 0')
          .required('Amount is required'),
      })
    ),

    accepted: yup.boolean().optional(),
  })
}

export const getBlendsAttributeWarnings = (
  attributes: TAttribute[],
  rules: Record<string, TRule>
): Record<
  string,
  { range_min?: string; range_max?: string; range_avg?: string }
> => {
  const warningMap: Record<
    string,
    { range_min?: string; range_max?: string; range_avg?: string }
  > = {}

  if (!Array.isArray(attributes)) return warningMap

  for (const attr of attributes) {
    const rule = rules[attr.name]
    if (!rule) continue

    const min = Number(attr.range_min)
    const max = Number(attr.range_max)
    const avg = Number(attr.range_avg)

    if (!warningMap[attr.name]) {
      warningMap[attr.name] = {}
    }

    // RANGE MIN warning
    if (
      rule.warnBelow !== undefined &&
      rule.hardMin !== undefined &&
      !isNaN(min) &&
      min < rule.warnBelow &&
      min >= rule.hardMin
    ) {
      warningMap[attr.name].range_min =
        `Below recommended (${min} < ${rule.warnBelow})`
    }

    // RANGE MAX warning
    if (
      rule.warnAbove !== undefined &&
      rule.hardMax !== undefined &&
      !isNaN(max) &&
      max > rule.warnAbove &&
      max <= rule.hardMax
    ) {
      warningMap[attr.name].range_max =
        `Above recommended (${max} > ${rule.warnAbove})`
    }

    // RANGE AVG warning - below
    if (
      rule.warnBelow !== undefined &&
      rule.hardMin !== undefined &&
      !isNaN(avg) &&
      avg < rule.warnBelow &&
      avg >= rule.hardMin
    ) {
      warningMap[attr.name].range_avg =
        `Below recommended (${avg} < ${rule.warnBelow})`
    }

    // RANGE AVG warning - above
    if (
      rule.warnAbove !== undefined &&
      rule.hardMax !== undefined &&
      !isNaN(avg) &&
      avg > rule.warnAbove &&
      avg <= rule.hardMax
    ) {
      warningMap[attr.name].range_avg =
        `Above recommended (${avg} > ${rule.warnAbove})`
    }
  }

  return warningMap
}
